export const ops = {
  rail: {
    size: '10px',
    background: '#000000',
    opacity: 0.15,
    gutterOfSide: '5px' // 距离容器的距离
  },
  bar: {
    onlyShowBarOnScroll: false, // 只有在滚动的时候显示bar
    background: '#000000',
    opacity: 0.25,
    size: '10px',
    keepShow: true // 保持显示滚动条
  },
  vuescroll: {
    wheelScrollDuration: 300
  }
}


export const opsHorizontal = function (options) {

  return {
     rail: {
        size: '0px',
        background: '#000000',
        opacity: 0.15,
        gutterOfSide: '0px' // 距离容器的距离
      },
      bar: {
        onlyShowBarOnScroll: false, // 只有在滚动的时候显示bar
        background: '#fff',
        opacity: 0.25,
        size: '0px',
        keepShow: true // 保持显示滚动条
      },
      vuescroll: {
        wheelScrollDuration: 300
      }
  }
}